export default [
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/wallet/mine.vue'),
    meta: {
      auth: true,
      title: '用户中心',
      keepAlive: false,
      headerTheme: 'dark'
    }
  },
  {
    path: '/walletLog',
    name: 'WalletLog',
    component: () => import('@/views/wallet/walletLog.vue'),
    meta: {
      auth: true,
      title: '资金记录',
      keepAlive: false,
      headerTheme: 'dark'
    }
  },
  {
    path: '/withdrawal',
    name: 'Withdrawal',
    component: () => import('@/views/wallet/withdrawal.vue'),
    meta: {
      auth: true,
      title: '提现',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]
